import { TemplateStage3Form } from './TemplateStage3Form';

export default TemplateStage3Form;